import { render } from "./AddOutsideDepartment.vue?vue&type=template&id=59ba8a3e&scoped=true&ts=true"
import script from "./AddOutsideDepartment.vue?vue&type=script&lang=ts"
export * from "./AddOutsideDepartment.vue?vue&type=script&lang=ts"

import "./AddOutsideDepartment.vue?vue&type=style&index=0&id=59ba8a3e&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59ba8a3e"]])

export default __exports__